import { createSlice, current } from "@reduxjs/toolkit";
import { MediaTypeEum } from "../../core/enumerations/MediaTypeEnum";
import { getCookies, setCookies } from "../../utils/Cookies";
import {
  getLocalStorageItem,
  setLocalStorageItem,
} from "../../utils/LocalStorage";

export interface IProfileState {
  isLoading: boolean;
  error: string | null;
  success: string;
  message: string;
  profileDetails: any;
  profileInfoReduxState: any;
  profileInfoReduxStateError: any;
  profilePosts: any;
  isFollowOrUnFollowUser: boolean;
  followingLists: any;
  followersLists: any;
  shareUsersList: any;
  mutualsList: any;
  isProfileDetailsUpdated: boolean;
  isPostSavedOrUnSaved: boolean;
  savedPostLists: any;
  isPostLikedOrUnliked: boolean;
  searchedLikeLists: any;
  isPictureUploaded: boolean;
  searchKey: string;
  isProfilePictureDeleted: boolean;
  isSavedPostFetched: boolean;
  isProfileDetailsFetched: boolean;
  tabValue: number;
}

const initialState: IProfileState = {
  isLoading: false,
  error: "",
  success: "",
  message: "",
  tabValue: 0,
  profileDetails: {},
  profileInfoReduxState: {
    userId: "",
    profileImage: "",
    coverImage: "",
    userName: "",
    name: "",
    skills: [],
    gender: "",
    describeInfo: "",
    websiteLink: "",
    addCollege: "",
    addHighSchool: "",
    addWork: "",
    country: "",
    countryCode: "",
    city: "",
    state: "",
    stateCode: "",
    instagramUrl: "",
    pinterestUrl: "",
    youtubeUrl: "",
    facebookUrl: "",
    additionalInfo: "",
    coverImageFile: "",
    profileImageFile: "",
  },
  isFollowOrUnFollowUser: false,
  followingLists: {},
  followersLists: {},
  shareUsersList: {},
  mutualsList: {},
  isProfileDetailsUpdated: false,
  profileInfoReduxStateError: {
    userNameError: "",
    skillsError: "",
    websiteLinkError: "",
    instagramUrlError: "",
    facebookUrlError: "",
    pinterestUrlError: "",
    youtubeUrlError: "",
  },
  profilePosts: [],
  isPostSavedOrUnSaved: false,
  savedPostLists: [],
  isPostLikedOrUnliked: false,
  searchedLikeLists: [],
  isPictureUploaded: false,
  searchKey: "",
  isProfilePictureDeleted: false,
  isSavedPostFetched: false,
  isProfileDetailsFetched: false,
};

export const ProfileRedux: any = createSlice({
  name: "ProfileRedux",
  initialState,
  reducers: {
    // set-profile-state
    setProfileState: (state: any, action: any) => {
      const newState = {
        ...state,
        [action.payload.key]: action.payload.value,
      };
      return newState;
    },

    // get - profile by id
    getProfileDetailsByIdRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProfileDetailsFetched: true,
      };
      return newState;
    },

    getProfileDetailsByIdSuccess: (state: any, action: any) => {
      const cachedUserDetails: any = getCookies("userDetails");
      const userDetails = JSON.parse(cachedUserDetails);

      const changeCachData: any = {
        ...userDetails,
        profilePic:
          action?.payload?.data?.id === userDetails?.id
            ? action?.payload?.data?.profilePic
            : userDetails?.profilePic,
        coverPic:
          action?.payload?.data?.id === userDetails?.id
            ? action?.payload?.data?.coverPic
            : userDetails?.coverPic,
      };
      // setLocalStorageItem("userDetails", JSON.stringify(changeCachData));
      setCookies("userDetails", JSON.stringify(changeCachData));

      const newState = {
        ...state,
        error: null,
        profileDetails: action.payload?.data,
        isLoading: false,
        isProfileDetailsFetched: true,
      };
      return newState;
    },

    getProfileDetailsByIdFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileDetailsFetched: false,
      };
      return newState;
    },

    // follow - api
    followOrUnFollowUserRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: true,
        success: false,
        message: "",
        isFollowOrUnFollowUser: false,
      };
      return newState;
    },
    followOrUnFollowUserSuccess: (state: any, action: any) => {
      console.log(action.payload, "action.payload")
      const newState = {
        ...state,
        // isLoading: false,
        success: true,
        message: action.payload.message,
        isFollowOrUnFollowUser: true,
      };
      return newState;
    },
    followOrUnFollowUserFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: false,
        isFollowOrUnFollowUser: false,
        errorMessage: action?.payload,
      };
      return newState;
    },

    // getAll Following list - api
    getAllFollowingRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        // getAllFollowing: false,
      };
      return newState;
    },
    getAllFollowingSuccess: (state: any, action: any) => {
      const previousFollowingList = current(state?.followingLists);
      const response = action.payload?.data;
      const previousResponseData =
        response?.currentPage === 1 ? [] : previousFollowingList?.responseData;
      const newState = {
        ...state,
        isLoading: false,
        getAllFollowing: true,
        followingLists: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...previousResponseData, ...response.responseData],
        },
      };
      return newState;
    },
    getAllFollowingFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        // getAllFollowing: false,
        errorMessage: action?.payload,
      };
      return newState;
    },

    // getAll share list - api
    getAllShareRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },


    getAllShareSuccess: (state: any, action: any) => {
      const previousList = current(state?.shareUsersList);
      const response = action.payload?.data;
      const previousResponseData =
        response?.currentPage === 1 ? [] : previousList?.responseData ? previousList?.responseData : [];
      const newState = {
        ...state,
        isLoading: false,
        shareUsersList: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...response.responseData],
        },
      };
      return newState;
    },

    getAllShareFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        errorMessage: action?.payload,
      };
      return newState;
    },

    // getAll Follower list - api
    getAllFollowerRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    getAllFollowerSuccess: (state: any, action: any) => {
      const previousFollowerList = current(state?.followersLists);
      const response = action.payload?.data;

      const previousResponseData =
        response?.currentPage === 1 ? [] : previousFollowerList?.responseData;
      const newState = {
        ...state,
        isLoading: false,
        followersLists: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...previousResponseData, ...response.responseData],
        },
      };
      return newState;
    },
    getAllFollowerFailure: (state: any, action: any) => {
      const response = action.payload;
      const newState = {
        ...state,
        isLoading: false,
        errorMessage: response,
      };
      return newState;
    },

    // getAll mutuals list - api
    getAllMutualRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },


    getAllMutualSuccess: (state: any, action: any) => {
      const previousList = current(state?.mutualsList);
      const response = action.payload?.data;
      const previousResponseData =
        response?.currentPage === 1 ? [] : previousList?.responseData ? previousList?.responseData : [];
      const newState = {
        ...state,
        isLoading: false,
        mutualsList: {
          currentPage: response?.currentPage,
          totalPages: response?.totalPages,
          responseData: [...response.responseData],
        },
      };
      return newState;
    },

    getAllMutualFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        errorMessage: action?.payload,
      };
      return newState;
    },


    // update About Profile
    updateProfileDetailsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isProfileDetailsUpdated: false,
      };
      return newState;
    },
    updateProfileDetailsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileDetailsUpdated: true,
      };
      return newState;
    },
    updateProfileDetailsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfileDetailsUpdated: false,
        errorMessage: action?.payload,
      };
      return newState;
    },

    // search following
    searchUserInFollowingListRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    searchUserInFollowingListSuccess: (state: any, action: any) => {
      const response = action.payload;
      const newState = {
        ...state,
        isLoading: false,
        getAllFollowingListBySearch: response,
        followingLists: {
          ...response,
          responseData: response?.data?.data,
        },
      };
      return newState;
    },

    searchUserInFollowingListFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // search followers
    searchUserInFollowersListRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    searchUserInFollowersListSuccess: (state: any, action: any) => {
      const response = action.payload;
      const newState = {
        ...state,
        isLoading: false,
        followersLists: { ...response, responseData: response?.data?.data },
      };
      return newState;
    },
    searchUserInFollowersListFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    // search share users
    searchUserInShareListRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },

    searchUserInShareListSuccess: (state: any, action: any) => {
      const response = action.payload;
      const newState = {
        ...state,
        isLoading: false,
        shareUsersList: {
          ...response,
          responseData: response?.data?.data?.responseData,
        },
      };
      return newState;
    },

    searchUserInShareListFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    //  get All Saved Post
    getAllSavedPostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isSavedPostFetched: true,
      };
      return newState;
    },
    getAllSavedPostSuccess: (state: any, action: any) => {
      const previousSavedPost = current(state?.savedPostLists);

      let response = {
        ...action?.payload?.data,
        responseData: action?.payload?.data?.responseData?.map(
          (postData: any) => {
            return {
              ...postData,
              currentPage: action?.payload?.currentPage,
              postMedias: postData?.postMedias?.map((post: any) => {
                if (
                  post?.mediaType === MediaTypeEum.video ||
                  post?.mediaType === MediaTypeEum.voice ||
                  post?.mediaType === MediaTypeEum.audio
                ) {
                  return {
                    ...post,
                    isPlaying: false,
                    isMute: false,
                  };
                } else {
                  return post;
                }
              }),
            };
          }
        ),
      };

      const previousPostMedias =
        response?.currentPage === 1 ? [] : previousSavedPost?.responseData;

      const newState = {
        ...state,
        isLoading: false,
        savedPostLists: {
          ...response,
          responseData: [...previousPostMedias, ...response?.responseData],
        },
        isSavedPostFetched: false,
      };

      return newState;
    },
    getAllSavedPostFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isSavedPostFetched: false,
      };
      return newState;
    },

    // -----------------------save post to fav-------------------------

    //  save Post To Favourite
    saveOrUnsavePostToFavouriteRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: true,
        isPostSavedOrUnSaved: false,
      };
      return newState;
    },
    saveOrUnsavePostToFavouriteSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: false,
        isPostSavedOrUnSaved: true,
      };
      return newState;
    },
    saveOrUnsavePostToFavouriteFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostSavedOrUnSaved: false,
      };
      return newState;
    },

    //  get Liked Post list
    getLikedPostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
      };
      return newState;
    },
    getLikedPostSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        searchedLikeLists: action.payload?.data,
      };
      return newState;
    },
    getLikedPostFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },

    //  get Post view count
    getPostViewRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: true,
      };
      return newState;
    },
    getPostViewSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        // searchedLikeLists: action.payload?.data,
      };
      return newState;
    },
    getPostViewFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
      };
      return newState;
    },


    //  like Post Api
    likeOrUnlikePostRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: true,
        isPostLikedOrUnliked: false,
      };
      return newState;
    },
    likeOrUnlikePostSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: false,
        isPostLikedOrUnliked: true,
      };
      return newState;
    },
    likeOrUnlikePostFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPostLikedOrUnliked: false,
      };
      return newState;
    },

    //  get Search List In Like
    searchUserInLikeListsRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: true,
      };
      return newState;
    },
    searchUserInLikeListsSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: false,
        searchedLikeLists: {
          ...action.payload,
          responseData: action.payload?.data,
        },
      };
      return newState;
    },
    searchUserInLikeListsFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        // isLoading: false,
      };
      return newState;
    },

    //upload profile picture to AWS
    uploadProfilePictureToBackendRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: true,
        isPictureUploaded: false,
      };
      return newState;
    },
    uploadProfilePictureToBackendSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPictureUploaded: true,
      };
      return newState;
    },
    uploadProfilePictureToBackendFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isPictureUploaded: false,
      };
      return newState;
    },

    deleteProfilePicturesRequest: (state: any, action: any) => {
      const newState = {
        ...state,
        isProfilePictureDeleted: false,
      };
      return newState;
    },
    deleteProfilePicturesSuccess: (state: any, action: any) => {
      const newState = {
        ...state,
        isProfilePictureDeleted: true,
      };
      return newState;
    },
    deleteProfilePicturesFailure: (state: any, action: any) => {
      const newState = {
        ...state,
        isLoading: false,
        isProfilePictureDeleted: false,
      };
      return newState;
    },
  },
});

export const {
  setProfileState,

  getProfileDetailsByIdRequest,
  getProfileDetailsByIdSuccess,
  getProfileDetailsByIdFailure,

  followOrUnFollowUserRequest,
  followOrUnFollowUserSuccess,
  followOrUnFollowUserFailure,

  getAllFollowingRequest,
  getAllFollowingSuccess,
  getAllFollowingFailure,

  getAllFollowerRequest,
  getAllFollowerSuccess,
  getAllFollowerFailure,

  getAllShareRequest,
  getAllShareSuccess,
  getAllShareFailure,

  updateProfileDetailsRequest,
  updateProfileDetailsSuccess,
  updateProfileDetailsFailure,

  searchUserInFollowingListRequest,
  searchUserInFollowingListSuccess,
  searchUserInFollowingListFailure,

  searchUserInFollowersListRequest,
  searchUserInFollowersListSuccess,
  searchUserInFollowersListFailure,

  getAllSavedPostRequest,
  getAllSavedPostSuccess,
  getAllSavedPostFailure,

  saveOrUnsavePostToFavouriteRequest,
  saveOrUnsavePostToFavouriteSuccess,
  saveOrUnsavePostToFavouriteFailure,

  getLikedPostRequest,
  getLikedPostSuccess,
  getLikedPostFailure,

  getPostViewRequest,
  getPostViewSuccess,
  getPostViewFailure,


  likeOrUnlikePostRequest,
  likeOrUnlikePostSuccess,
  likeOrUnlikePostFailure,

  searchUserInLikeListsRequest,
  searchUserInLikeListsSuccess,
  searchUserInLikeListsFailure,

  uploadProfilePictureToBackendRequest,
  uploadProfilePictureToBackendSuccess,
  uploadProfilePictureToBackendFailure,

  deleteProfilePicturesRequest,
  deleteProfilePicturesSuccess,
  deleteProfilePicturesFailure,
} = ProfileRedux.actions;

export default ProfileRedux.reducer;
